import styled from '@emotion/styled';
import { AutoComplete } from 'src/components-dummy';

export const DataFieldsValuesAutoCompleteStyled = styled(AutoComplete)`
  width: 100%;
  min-width: 35%;

  ${({ disabled, theme }) => !disabled && `color: ${theme.palette.common.black};`}
`;
